<div *ngFor="let section of sections">
  <h3 id="{{ section.title }}" [ngClass]="isSelected(section.key || '') ? 'highlight' : ''" *ngIf="!isIAGPortalDocumentationPage && !isNDCManagement">{{ section.title }}</h3>
  <h4 [id]="section.heading" *ngIf="isIAGPortalDocumentationPage || isNDCManagement" [style.color]="section.titleColorClass">{{ section.title }}</h4>
  <div [innerHTML]="section.body | mdToHtml"></div>
  <div>
    <app-note [noteSections]="section.noteSections || []" *ngIf="section.noteSections?.length"></app-note>
  </div>
  <app-prism-xml *ngIf="section.xmlData && gettingStartedPage" [xmlData]="section.xmlData"></app-prism-xml>
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
  <app-iag-portal-accordian-section *ngIf="section.accordianSection" [accordianSections]="section.accordianSection"></app-iag-portal-accordian-section>
</div>
